<template>
  <div class="infor-bill">
    <div class="period d-none">
      <h2>KỲ LƯƠNG {{ period.title | convertFullDate }}</h2>
    </div>
    <div class="student_name">
      <p>Họ và tên giáo viên:</p>
      <span>{{ get(report, 'teacher.name') }}</span>
    </div>
    <div class="student_code">
      <p>Mã giáo viên:</p>
      <span>{{ get(report, 'teacher.code') }}</span>
    </div>
    <div class="student_class">
      <p>Lĩnh vực:</p>
      <span>{{ get(report, 'subjectGroup.title', 'Chưa phân công') }}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { get } from 'lodash'

export default {
  data() {
    return { get }
  },
  computed: {
    ...mapGetters({
      period: 'salaryPeriod/period',
      report: 'salaryReport/report'
    })
  }
}
</script>
<style lang="scss">
p,
span,
h2,
h3 {
  color: #212121;
}
.infor-bill {
  margin: 10px 0 0 20px;
}
.period {
  padding-top: 12px;
}
.infor-bill h2,
.bill_content_wrap h2 {
  text-transform: uppercase;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  margin: 30px 0;
}
.infor-bill p {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin: 1px 10px 0 0;
}
.infor-bill h2 {
  text-transform: uppercase;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  margin: 30px 0;
}
.infor-bill > .student_name,
.student_code,
.student_class {
  display: flex;
  margin: 8px 0;
}
</style>
